import PropTypes from 'prop-types';

import stylesStatus from './utils';
import './StatusProvider.scss';

const StatusProvider = ({ idStatus }) => {
  const status = stylesStatus.find((item) => item.idStatus === idStatus);

  return <div className={`syles-status ${status.backgroundStyle}`}>{status.label}</div>;
};

export default StatusProvider;

StatusProvider.propTypes = {
  idStatus: PropTypes.bool
};
StatusProvider.defaultProps = {
  idStatus: null
};
